<template>
    <div>
        <e-dialog
                :dialogTitle="'产品类目'"
                :centerDialogVisible="productCategoryVisible"
                @updateVisible="resetPopupData"
                @resetPopupData="resetPopupData"
                @submitPopupData="submitPopupData"
                :popupWidth="'500px'"
        >
            <div>
                <el-tree
                        v-loading="loading"
                        ref="tree"
                        :data="categoryTreeData"
                        highlight-current
                        @node-click="handleNodeClick"
                        :indent="30"
                        node-key="lbbm">
                    <template slot-scope="{ node, data }">
                        <div style="width: 90%; display: flex">
                            <span>{{ data.text }}</span>
                        </div>
                    </template>
                </el-tree>
            </div>
        </e-dialog>
    </div>
</template>

<script>
    import eDialog from "@/modules/projectA/components/common/e-dialog.vue";
    export default {
        name: "productCategoryDialog",
        components:{eDialog},
        props:{
            categoryTreeData:Array,
            productCategoryVisible:Boolean,
        },
        data(){
            return{
                loading:false,
                clickData:{},
            }
        },
        methods:{
            //点击树的节点
            handleNodeClick(node){
                if(node.children && node.children.length > 0){
                    this.$message.warning('请选择到物料类目小类。');
                    return false;
                };
               this.clickData = node;
            },
            resetPopupData(){
                this.$emit('closeDialog');
            },
            submitPopupData(){
                if(Object.keys(this.clickData).length  === 0){
                    this.$message.warning('请选择到物料类目小类。');
                    return false;
                }
                if(this.clickData.children && this.clickData.children.length > 0){
                    this.$message.warning('请选择到物料类目小类。');
                    return false;
                };
                this.$emit('confirmCategory',this.clickData);
            },
        },

    }
</script>

<style scoped lang="scss">
</style>